import { render, staticRenderFns } from "./GetTicketDetail.vue?vue&type=template&id=60389c40&scoped=true&"
import script from "./GetTicketDetail.vue?vue&type=script&lang=js&"
export * from "./GetTicketDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60389c40",
  null
  
)

export default component.exports